import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";

function useDynamicState<T>(initialState:T): [T, React.RefObject<T>, Dispatch<SetStateAction<T>>] {
    const [state, setState] = useState<T>(initialState);
    const stateRef = useRef<T>(state);
  
    useEffect(() => {
      stateRef.current = state;
    }, [state]);
  
    return [state, stateRef, setState];
}

export default useDynamicState;